/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Recent_ActivityInputs */

const en_dashboard_recent_activity = /** @type {(inputs: Dashboard_Recent_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent Activity`)
};

const de_dashboard_recent_activity = /** @type {(inputs: Dashboard_Recent_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelle Aktivitäten`)
};

const fr_dashboard_recent_activity = /** @type {(inputs: Dashboard_Recent_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activité récente`)
};

const es_dashboard_recent_activity = /** @type {(inputs: Dashboard_Recent_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actividad reciente`)
};

const it_dashboard_recent_activity = /** @type {(inputs: Dashboard_Recent_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attività Recente`)
};

const nl_dashboard_recent_activity = /** @type {(inputs: Dashboard_Recent_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recente Activiteit`)
};

const pl_dashboard_recent_activity = /** @type {(inputs: Dashboard_Recent_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnia aktywność`)
};

const fi_dashboard_recent_activity = /** @type {(inputs: Dashboard_Recent_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeaikainen toiminta`)
};

const da_dashboard_recent_activity = /** @type {(inputs: Dashboard_Recent_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seneste aktivitet`)
};

const sv_dashboard_recent_activity = /** @type {(inputs: Dashboard_Recent_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senaste Aktivitet`)
};

/**
* | output |
* | --- |
* | "Recent Activity" |
*
* @param {Dashboard_Recent_ActivityInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_recent_activity = /** @type {((inputs?: Dashboard_Recent_ActivityInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Recent_ActivityInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_recent_activity(inputs)
	if (locale === "fr") return fr_dashboard_recent_activity(inputs)
	if (locale === "es") return es_dashboard_recent_activity(inputs)
	if (locale === "it") return it_dashboard_recent_activity(inputs)
	if (locale === "nl") return nl_dashboard_recent_activity(inputs)
	if (locale === "pl") return pl_dashboard_recent_activity(inputs)
	if (locale === "fi") return fi_dashboard_recent_activity(inputs)
	if (locale === "da") return da_dashboard_recent_activity(inputs)
	if (locale === "sv") return sv_dashboard_recent_activity(inputs)
	return en_dashboard_recent_activity(inputs)
});